var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodHot = function SvgFoodHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m4.6 4.6.034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L5.6.6m4.5 4 .034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L11.1.6m4.5 4 .034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L16.6.6M.6 9.1c.04 1.77.296 3.217.756 4.327a10 10 0 0 0 5.415 5.412v.761a1 1 0 0 0 1 1h5.657a1 1 0 0 0 1-1v-.761a10 10 0 0 0 5.416-5.412c.46-1.11.716-2.556.756-4.327a.49.49 0 0 0-.495-.5H1.095a.49.49 0 0 0-.495.5"
  })));
};
export default SvgFoodHot;